import { useEffect, useState } from "react";
import  PersonIcon  from "../../../layout/left_menu_icons/person.svg";
import ViewDeletePreCandidate from "../../precandidate/delete/ViewDeletePreCandidate";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GlobalService } from "../../../services/GlobalService";
import { useTranslation } from "react-i18next";
import "../Candidate/Candidate.scss";

export default function PrecandidateDetailsPage(props) {
  const [precandidate, setPrecandidate] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    let precandidateId = props.match.params.id;

    setSearchTerm(props.match.params.searchTerm);

    if (precandidateId) {
      GlobalService.GetPrecandidateById(precandidateId).then((data) => {
        if (data) {
          setPrecandidate(data);
        }
      });
    }
  }, []);

  function goBack() {
    if (searchTerm) history.push(`/global/candidates/${searchTerm}`);
    else history.push("/global/candidates");
  }

  return (
    <div className="mt-4">
      <header className="page-header">
        <div className="header-title" style={{marginBottom:"-20px", marginLeft: "-5px"}}>
          <div className="title">
            <img src={PersonIcon} alt="pc-icon" />
            <h1 style={{marginTop:"10px"}}>{t("Pre-Candidates")}</h1>
          </div>
          <div className="subtitle">{t("Recruitment / Pre-Candidates")}</div>
        </div>
      </header>
      <div className="text-end col-auto" style={{marginBottom:"-20px"}}>
        <a
          href="#!"
          className="btn app-button btn-second btn-lg"
          onClick={goBack}
          style={{marginTop: "-70px"}}
        >
          {t("Back")}
        </a>
      </div>
      <hr></hr>
      <ViewDeletePreCandidate precandidate={precandidate} />
    </div>
  );
}
